
/* eslint-env browser */
/* eslint no-unused-vars: 0 */

import isArray from 'lodash/isArray';
import map from 'lodash/map';
import reduce from 'lodash/reduce';

var supportsBeacon = Boolean(window.navigator.sendBeacon);

export default function send(url, data, sdkConfig) {
  // if there is as large number of events, only send 10 in each request
  /* eslint no-param-reassign: 0 */
  var eventChunks = isArray(data) ? reduce(data, function (accl, event) {
    if (accl[0].length >= 10) {
      accl = [[event]].concat(accl);
    } else {
      accl[0].push(event);
    }
    return accl;
  }, [[]]) : [[data]];

  if (sdkConfig.useBeacon && sdkConfig.useBeaconWhenAvailable && supportsBeacon) {
    var result = reduce(eventChunks, function (previousStatus, eventChunk) {
      var blob = new Blob([JSON.stringify(eventChunk)]);
      return previousStatus && window.navigator.sendBeacon(url, JSON.stringify(eventChunk));
    }, true);

    if (result) {
      return Promise.resolve(true);
    }
    return Promise.reject(false);
  }

  var requests = map(eventChunks, function (eventChunk) {
    return fetch(url, {
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      method: 'POST',
      body: JSON.stringify(eventChunk)
    });
  });

  return Promise.all(requests);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-sdk/dist/ejs/network-browser.js
// module id = 1191
// module chunks = 0